import { createIcon } from '@chakra-ui/react'

const IconRetry = createIcon({
  displayName: 'IconRetry',
  viewBox: '0 0 18 18',
  path: (
    <path
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
      d="M1.5 3v4.5h4.5M16.5 15v-4.5H12M2.34 11.25a6.75 6.75 0 0011.32 2.52l2.84-2.77M1.5 7l2.84-2.77A6.75 6.75 0 0115.66 6.75"
    />
  )
})

export default IconRetry
